class TemplateIndexJS {
    constructor() {
        if(window.screen.width < 768 && document.querySelector('main .main-slider-wrapper') != null) {
            document.querySelector('main .main-slider-wrapper').insertAdjacentElement('afterend', document.querySelector('.shopify-section.collection-list-section'));
            document.querySelector('main .shopify-section.collection-list-section').insertAdjacentElement('afterend', document.querySelector('.shopify-section.index-featured-collectiion'));
        }
    }
}

typeof TemplateIndexJS !== 'undefined' && new TemplateIndexJS();